import { ImagePreview } from '@aigc/components';
import { useOverlay } from '@aigc/overlay-hook';
import { Button, type ButtonProps } from 'antd';

export const MediaPreviewButton = ({ href, ...props }: ButtonProps) => {
  const [openPreview] = useOverlay();

  return (
    <Button
      {...props}
      onClick={(ev) => {
        ev.stopPropagation();
        openPreview(<ImagePreview src={href}></ImagePreview>);
      }}
    ></Button>
  );
};
